import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export const exportBankReconExcel = async (rowsRaw: any[] = [], month?: any) => {
    const rows = (rowsRaw || []).filter(r => r?.paymentDateA !== 'Total' && r?.paymentDateB !== 'Total');

    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Bank Recon');

    const leftStartCol = 1;
    const rightStartCol = 7;

    const titleRow = 1;
    const subTitleRow = 2;
    const headerRow = 3;
    const dataStartRow = 4;

    const headers = ['Payment Date', 'Adyen (net)', 'Bank', 'Var'];
    const headersRight = ['Payment Date', 'AMEX(net)', 'Bank', 'Var'];

    [
        { key: 'dateA', width: 14 },
        { key: 'netA', width: 14 },
        { key: 'bankA', width: 14 },
        { key: 'varA', width: 14 },
    ].forEach((c, i) => {
        ws.getColumn(leftStartCol + i).width = c.width;
    });

    [
        { key: 'dateB', width: 14 },
        { key: 'netB', width: 14 },
        { key: 'bankB', width: 14 },
        { key: 'varB', width: 14 },
    ].forEach((c, i) => {
        ws.getColumn(rightStartCol + i).width = c.width;
    });

    const headerStyle: Partial<ExcelJS.Style> = {
        font: { bold: true },
        alignment: { vertical: 'middle', horizontal: 'center' },
        border: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' },
        },
    };
    const cellBorder = {
        top: { style: 'thin' as const },
        left: { style: 'thin' as const },
        bottom: { style: 'thin' as const },
        right: { style: 'thin' as const },
    };

    ws.mergeCells(titleRow, leftStartCol, titleRow, leftStartCol + 3);
    ws.getCell(titleRow, leftStartCol).value = 'Adyen';
    ws.getCell(titleRow, leftStartCol).font = { bold: true, size: 14 };
    ws.getCell(titleRow, leftStartCol).alignment = { horizontal: 'center' };

    ws.mergeCells(subTitleRow, leftStartCol, subTitleRow, leftStartCol + 3);
    ws.getCell(subTitleRow, leftStartCol).value = 'Bank vs Adyen recon';
    ws.getCell(subTitleRow, leftStartCol).alignment = { horizontal: 'center' };

    ws.mergeCells(titleRow, rightStartCol, titleRow, rightStartCol + 3);
    ws.getCell(titleRow, rightStartCol).value = 'AMEX';
    ws.getCell(titleRow, rightStartCol).font = { bold: true, size: 14 };
    ws.getCell(titleRow, rightStartCol).alignment = { horizontal: 'center' };

    ws.mergeCells(subTitleRow, rightStartCol, subTitleRow, rightStartCol + 3);
    ws.getCell(subTitleRow, rightStartCol).value = 'Bank vs AMEX recon';
    ws.getCell(subTitleRow, rightStartCol).alignment = { horizontal: 'center' };

    headers.forEach((h, i) => {
        const c = ws.getCell(headerRow, leftStartCol + i);
        c.value = h;
        Object.assign(c, { style: headerStyle });
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
    });

    headersRight.forEach((h, i) => {
        const c = ws.getCell(headerRow, rightStartCol + i);
        c.value = h;
        Object.assign(c, { style: headerStyle });
        c.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF5F5F5' } };
    });

    const setDate = (r: number, c: number, dateStr?: string) => {
        const cell = ws.getCell(r, c);
        if (dateStr) {
            const d = new Date(dateStr);
            if (!isNaN(d.getTime())) {
                cell.value = d;
                cell.numFmt = 'd-mm-yyyy';
            } else {
                cell.value = dateStr;
            }
        } else {
            cell.value = null;
        }
        cell.border = cellBorder;
    };

    const setNum = (r: number, c: number, n?: number) => {
        const cell = ws.getCell(r, c);
        cell.value = typeof n === 'number' ? n : 0;
        cell.numFmt = '#,##0.00';
        cell.border = cellBorder;
    };

    rows.forEach((row, i) => {
        const r = dataStartRow + i;

        setDate(r, leftStartCol + 0, row.paymentDateA);
        setNum(r, leftStartCol + 1, Number(row.adyenNet));
        setNum(r, leftStartCol + 2, Number(row.adyenBank));
        setNum(r, leftStartCol + 3, Number(row.adyenVar));

        setDate(r, rightStartCol + 0, row.paymentDateB);
        setNum(r, rightStartCol + 1, Number(row.amexNet));
        setNum(r, rightStartCol + 2, Number(row.amexBank));
        setNum(r, rightStartCol + 3, Number(row.amexVar));
    });

    const totalRowIdx = dataStartRow + rows.length;

    ws.mergeCells(totalRowIdx, leftStartCol, totalRowIdx, leftStartCol);
    const totLabelLeft = ws.getCell(totalRowIdx, leftStartCol);
    totLabelLeft.value = 'Total';
    totLabelLeft.font = { bold: true };
    totLabelLeft.border = cellBorder;

    const leftCols = [leftStartCol + 1, leftStartCol + 2, leftStartCol + 3];
    leftCols.forEach((c) => {
        const start = ws.getCell(dataStartRow, c).address;
        const end = ws.getCell(totalRowIdx - 1, c).address;
        const cell = ws.getCell(totalRowIdx, c);
        cell.value = { formula: `SUM(${start}:${end})` };
        cell.numFmt = '#,##0.00';
        cell.font = { bold: true };
        cell.border = cellBorder;
    });

    ws.mergeCells(totalRowIdx, rightStartCol, totalRowIdx, rightStartCol);
    const totLabelRight = ws.getCell(totalRowIdx, rightStartCol);
    totLabelRight.value = 'Total';
    totLabelRight.font = { bold: true };
    totLabelRight.border = cellBorder;

    const rightCols = [rightStartCol + 1, rightStartCol + 2, rightStartCol + 3];
    rightCols.forEach((c) => {
        const start = ws.getCell(dataStartRow, c).address;
        const end = ws.getCell(totalRowIdx - 1, c).address;
        const cell = ws.getCell(totalRowIdx, c);
        cell.value = { formula: `SUM(${start}:${end})` };
        cell.numFmt = '#,##0.00';
        cell.font = { bold: true };
        cell.border = cellBorder;
    });

    for (let r = headerRow; r <= totalRowIdx; r++) {
        const fromCol = leftStartCol;
        const toCol = rightStartCol + 3;
        for (let c = fromCol; c <= toCol; c++) {
            ws.getCell(r, c).border = ws.getCell(r, c).border || cellBorder;
        }
    }

    const buf = await wb.xlsx.writeBuffer();
    const monthSuffix = month ? `_${(typeof month === 'string' ? month : '') || ''}` : '';
    saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
        `bank_reconciliation_${monthSuffix || ''}.xlsx`);
};